import _ from 'lodash';
import fileDownload from '../../../utils/file-download';
import getSasToken from '../../../apis/sasToken';

export default {
  methods: {
    async downloadAttachment(file, productId, roleId, roleInfo) {
      this.loaderStatus = true;
      let containerName = '';
      if (roleId === roleInfo['RA Admin'] || roleId === roleInfo['RA Viewer']) {
        const record = this.totalRecordsData.find((item) => item.registration_id === productId);
        if (record) containerName = record.accountId;
      } else { containerName = _.padStart(localStorage.getItem('accountId'), 3, 0); }
      const sasToken = await getSasToken({
        container_name: containerName,
        file_name: '',
        folder_name: 'registrations',
        permissions: 'read',
        storage_name: 'bnprodstorage',
      });
      if (!sasToken) {
        this.loaderStatus = false;
        this.$notify({
          clear: true,
          group: 'custom-notification',
        });
        this.$notify({
          type: 'error',
          title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
          text: 'Unable to download file',
          group: 'custom-notification',
        });
        return;
      }
      const url = `${process.env.VUE_APP_PYTHON_AZURE_BLOB_URL}/${containerName}/${file}${sasToken}`;
      const response = await fileDownload(url);
      this.loaderStatus = false;
      if (response && response.error) {
        this.$notify({
          clear: true,
          group: 'custom-notification',
        });
        this.$notify({
          type: 'error',
          title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
          text: response.error.errorMessage,
          group: 'custom-notification',
        });
      }
    },
  },
};
